import Helper from "../../Helper";
import { Delivery } from "../../models/Delivery";
import { plotFetch } from "../Helper/ApiRequest";

export function getDeliveryAreaConflicts(
    team_subdomain: string,
    project_token: string,
    area_id: number,
    timezone: string
): Promise<Delivery[]> {
    const url = `${Helper.baseUrlAltSubdomain(team_subdomain)}/projects/${project_token}/deliveries/area_conflicts?id=${area_id}`;

    return plotFetch(url, { method: "GET" })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            return response.map((delivery: any) => Delivery.fromApiObject(delivery, timezone));
        })
        .catch((error) => {
            return [];
        });
}
